import { Controller } from "@hotwired/stimulus"

// Usage:
// <span data-controller="ellipsis-tooltip"
//       data-ellipsis-tooltip-target="text"
//       data-tooltip="Default tooltip text"
//       data-tooltip-if-ellipsis="Tooltip when truncated">
//       other data attributes as in tooltip controller.
// </span>

export default class extends Controller {
    connect() {
        this.defaultTooltip = this.element.dataset.tooltip
        this.currentTooltip = null

        this.element.removeAttribute('data-tooltip')
        this.updateTooltip()

        this.observer = new ResizeObserver(() => this.updateTooltip())
        this.observer.observe(this.element)
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
        this.destroyTooltip()
    }

    updateTooltip() {
        const el = this.element
        const isTruncated = el.scrollWidth > el.clientWidth

        const tooltipContent = isTruncated
            ? el.dataset.tooltipIfEllipsis || this.defaultTooltip
            : this.defaultTooltip

        if (!tooltipContent) return
        if (tooltipContent === this.currentTooltip) return

        this.currentTooltip = tooltipContent
        this.destroyTooltip()

        this.instance = M.Tooltip.init(el, {
            enterDelay: Number(el.dataset.tooltipEnterDelay) || 200,
            html: tooltipContent })

        const customClasses = this.element.dataset.tooltipClasses
        if (customClasses && this.instance.tooltipEl) {
            this.instance.tooltipEl.classList.add(...customClasses.split(' '))
        }
    }

    destroyTooltip() {
        if (this.instance) {
            this.instance.destroy()
            this.instance = null
        }
    }
}